import axios from 'axios';
import { PIM_BASE_URL, SCP_BASE_URL } from '../constants';

export function getAPProducts(productReq){
    return axios.post(`${PIM_BASE_URL}/products/list`, productReq).then(res => res.data).catch(error => console.log(error));
}

export function getDepartments(departmentReq){
    return axios.post(`${SCP_BASE_URL}/departments/list`, departmentReq).then(res => res.data).catch(error => console.log(error));
}